/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GoogleSearchConsoleCannibalizationRowData } from './GoogleSearchConsoleCannibalizationRowData';
import {
    GoogleSearchConsoleCannibalizationRowDataFromJSON,
    GoogleSearchConsoleCannibalizationRowDataFromJSONTyped,
    GoogleSearchConsoleCannibalizationRowDataToJSON,
    GoogleSearchConsoleCannibalizationRowDataToJSONTyped,
} from './GoogleSearchConsoleCannibalizationRowData';

/**
 * 
 * @export
 * @interface GoogleSearchConsoleCannibalizationPageData
 */
export interface GoogleSearchConsoleCannibalizationPageData {
    /**
     * 
     * @type {boolean}
     * @memberof GoogleSearchConsoleCannibalizationPageData
     */
    available?: boolean;
    /**
     * 
     * @type {string}
     * @memberof GoogleSearchConsoleCannibalizationPageData
     */
    completeness?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GoogleSearchConsoleCannibalizationPageData
     */
    publishedAt?: string | null;
    /**
     * 
     * @type {number}
     * @memberof GoogleSearchConsoleCannibalizationPageData
     */
    page?: number;
    /**
     * 
     * @type {number}
     * @memberof GoogleSearchConsoleCannibalizationPageData
     */
    limit?: number;
    /**
     * 
     * @type {number}
     * @memberof GoogleSearchConsoleCannibalizationPageData
     */
    totalRows?: number;
    /**
     * 
     * @type {number}
     * @memberof GoogleSearchConsoleCannibalizationPageData
     */
    totalPages?: number;
    /**
     * 
     * @type {Array<GoogleSearchConsoleCannibalizationRowData>}
     * @memberof GoogleSearchConsoleCannibalizationPageData
     */
    rows?: Array<GoogleSearchConsoleCannibalizationRowData>;
}

/**
 * Check if a given object implements the GoogleSearchConsoleCannibalizationPageData interface.
 */
export function instanceOfGoogleSearchConsoleCannibalizationPageData(value: object): value is GoogleSearchConsoleCannibalizationPageData {
    return true;
}

export function GoogleSearchConsoleCannibalizationPageDataFromJSON(json: any): GoogleSearchConsoleCannibalizationPageData {
    return GoogleSearchConsoleCannibalizationPageDataFromJSONTyped(json, false);
}

export function GoogleSearchConsoleCannibalizationPageDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): GoogleSearchConsoleCannibalizationPageData {
    if (json == null) {
        return json;
    }
    return {
        
        'available': json['available'] == null ? undefined : json['available'],
        'completeness': json['completeness'] === undefined ? undefined : json['completeness'] === null ? null : json['completeness'],
        'publishedAt': json['publishedAt'] === undefined ? undefined : json['publishedAt'] === null ? null : json['publishedAt'],
        'page': json['page'] == null ? undefined : json['page'],
        'limit': json['limit'] == null ? undefined : json['limit'],
        'totalRows': json['totalRows'] == null ? undefined : json['totalRows'],
        'totalPages': json['totalPages'] == null ? undefined : json['totalPages'],
        'rows': json['rows'] == null ? undefined : ((json['rows'] as Array<any>).map(GoogleSearchConsoleCannibalizationRowDataFromJSON)),
    };
}

export function GoogleSearchConsoleCannibalizationPageDataToJSON(json: any): GoogleSearchConsoleCannibalizationPageData {
    return GoogleSearchConsoleCannibalizationPageDataToJSONTyped(json, false);
}

export function GoogleSearchConsoleCannibalizationPageDataToJSONTyped(value?: GoogleSearchConsoleCannibalizationPageData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'available': value['available'],
        'completeness': value['completeness'],
        'publishedAt': value['publishedAt'],
        'page': value['page'],
        'limit': value['limit'],
        'totalRows': value['totalRows'],
        'totalPages': value['totalPages'],
        'rows': value['rows'] == null ? undefined : ((value['rows'] as Array<any>).map(GoogleSearchConsoleCannibalizationRowDataToJSON)),
    };
}

